import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3360/market/cart";
};

export const mallILoadCart = () => {
  const url = `${baseURL()}/`;

  return axios.post(url);
};

export const mallInsertToCart = (shop, product, params) => {
  const url = `${baseURL()}/add/${shop}/${product}`;

  return axios.post(url, params);
};

export const mallDeleteFromCart = params => {
  const url = `${baseURL()}/delete`;

  return axios.post(url, params);
};

export const mallUpdateCartItem = (shopID, cartID, params) => {
  const url = `${baseURL()}/edit/${shopID}/${cartID}`;

  return axios.post(url, params);
};
